import React from "react";

import Page from "../../../_components/Layout/Page";
import Button from "../../../_components/Button";
import FilterProducts from "./components/Filter";
import NoCertificateWarning from "../_components/NoCertificateWarning";

export default () => {
  function onClick(product) {
    window.location.href = `/product/${product.id}`;
  }

  const onGoToCreate = () =>{
    window.location.href = '/products/create'
  }

  return (
    <Page title="Produtos">
      <NoCertificateWarning />
      <div className="my-3" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <Button onClick={onGoToCreate}>Cadastrar novo produto <i className="fas fa-plus"></i></Button>
        <button 
          className="btn btn-outline-primary"
          style={{ background: '#fff', border: '1px solid #1a73e8', color: '#1a73e8', display: 'flex', alignItems: 'center', gap: '5px' }}
          onClick={() => window.dispatchEvent(new CustomEvent('exportProductCsv'))}
        >
          <i className="fas fa-file-excel"></i> Exportar cadastros de produtos para CSV
        </button>
      </div>
      <FilterProducts onClick={onClick} />
    </Page>
  );
};




// WEBPACK FOOTER //
// ./src/views/AppViews/Products/index.jsx